import { DEFAULT_NUMBER } from "../../../../types";
import { HttpClient, JSON_STRING, MHTTPCL } from "../../../../services/http/http-client";
import { ACCOUNTING_URL, MODIFICATION_URL } from "../../../../services/common-urls";
import { BOOKING_URL, BOOKINGS_STRING, SETTINGS_URL } from "../booking-service";
import { FILES_URL } from "../../../../dt-plugins/file-uploader/file.service";



const CALENDAR_BOOKINGS_DOCUMENTS = 'calendar_bookings_documents';

const DELETE_CALENDAR_DATE_DOCUMENT = 'delete_calendar_date_document';
const TEMPLATE_FEATURE = 'template_feature';
const GEN_SIGNED_DOC_FOR_PROMOTER_AGREEMENT = 'gen_signed_doc_id_for_promoter_agreement';
const BUILD_CHECKSUM = 'build_checksum';
const PROMOTER_INTERFACE = 'promoter_interface';
const INTERFACE = 'interface';
const BOOKING = 'booking';

const GEN_SIGNED_DOC_FOR_PROMOTER_VIEW = 'gen_signed_doc_id_for_promoter_view';
const DELETE_DOCUMENT_RELATION = 'delete_document_relation';
export const bookingDocumentService = {
  getDocuments: (calendarDateId = DEFAULT_NUMBER, options) => {
    return HttpClient.get2(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: CALENDAR_BOOKINGS_DOCUMENTS,
      calendar_date_id: calendarDateId
    }, options);
  },

  removeDocument: (
    documentId
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: DELETE_CALENDAR_DATE_DOCUMENT,
    document_id: documentId
  }),

  findTemplateFeature: (
    bookingTemplateId
  ) => HttpClient.get2(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: TEMPLATE_FEATURE,
    booking_template_id: bookingTemplateId
  }),

  generateSignedDocPromoterAgreement: (
    calendarDateId,
    documentId,
    signed_documents_id
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: GEN_SIGNED_DOC_FOR_PROMOTER_AGREEMENT,
    calendar_date_id: calendarDateId,
    signed_documents_id,
    document_id: documentId
  }),
  generateSignedDocPromoterView: (
    documentId,
    contactIdPromoter,
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: GEN_SIGNED_DOC_FOR_PROMOTER_VIEW,
    document_id: documentId,
    contact_id_promoter: contactIdPromoter,
  }),
  buildChecksum: (
    calendarDateId,
    signedDocumentId
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKING,
    action: BUILD_CHECKSUM,
    checksum_interface: PROMOTER_INTERFACE,
    checksum_section: INTERFACE,
    calendar_date_id: calendarDateId,
    signed_documents_id: signedDocumentId
  }),
  deleteDocumentRelation: ({
    fileId,
    fileRelationId
  }) => HttpClient.post(FILES_URL, {
    action: DELETE_DOCUMENT_RELATION,
    file_id: fileId,
    file_relation_id: fileRelationId
  }),

  getDocumentTemplate: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'templates',
    template_key: 'booking_document_and_files',
  }),
  getQuestionnairetemplate: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'templates',
    template_key: 'promoter_questionnaire_mail',
    output: JSON_STRING,
  }),
  getArtistOffertemplates: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'templates',
    template_key: 'offer_mail_to_artist',
    output: JSON_STRING,
  }),


  renderTemplate: (template_id, documents, files, invoices, subject, renderTemplateArgs) => MHTTPCL.post(SETTINGS_URL, {
    template_id: template_id,
    template_key: "booking_document_and_files",
    documents,
    files,
    invoices,
    subject,

    section: "templates",
    action: "render",
    ...renderTemplateArgs,
  }),
  renderQuestionnaireTemplate: (template_id, subject, templateArgs) => {
    return MHTTPCL.post(SETTINGS_URL, {
      template_id: template_id,
      template_key: "booking_document_and_files",
      subject,

      section: "templates",
      action: "render",
      ...templateArgs,
    })
  },
  renderArtistOfferTemplate: (template_id, subject, templateArgs) => {
    console.log({"template_id, subject, templateArgs": template_id, subject, templateArgs});
    return MHTTPCL.post(SETTINGS_URL, {
      template_key: "offer_mail_to_artist",
      section: "templates",
      action: "render",
      template_id,
      subject,
      ...templateArgs,
    })
  },

  addRemovePayPal: (
    invoice_id,
    addOrRemove
  ) => {
    return MHTTPCL.post(ACCOUNTING_URL, {
      section: 'invoices',
      action: 'addRemovePaypalEmail',
      invoice_id,
      addOrRemove,
    })
  }

};